import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Translation } from "react-i18next";

import {
    Button,
    Input,
    InputGroupAddon,
    InputGroup,
    UncontrolledTooltip
} from "reactstrap";

import {updateList, updateComponent} from '_actions';
import { findObjUpdate } from 'assets/util';

class BorderRadius extends Component {
    constructor(props) {
        super(props)

        const { component } = props;
        const { object } = component.hasOwnProperty("componentOwner") ? component.object.components[0] : component.components[0];

        const { style, value } = object.props;

        this.state = {
            isAll: true,
            borderTopLeftRadius: component && parseInt(style["borderTopLeftRadius"] == undefined ? "0px" : style["borderTopLeftRadius"]),
            borderTopRightRadius: component && parseInt(style["borderTopRightRadius"] == undefined ? "0px" : style["borderTopRightRadius"]),
            borderBottomRightRadius: component && parseInt(style["borderBottomRightRadius"] == undefined ? "0px" : style["borderBottomRightRadius"]),
            borderBottomLeftRadius: component && parseInt(style["borderBottomLeftRadius"] == undefined ? "0px" : style["borderBottomLeftRadius"]),
        }

    }

    checkIsEqual = () => {
        const { borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius } = this.state;
        if (borderTopLeftRadius == borderTopRightRadius == borderBottomRightRadius == borderBottomLeftRadius) {
            return true;
        } else {
            return false;
        }
    }


    setProperties = () => {

        let _clone = Object.assign({}, this.props.component);
        const that = this;

        if (_clone.hasOwnProperty("componentOwner")) {
            _clone.object.components[0].object.props.style = {
                ..._clone.object.components[0].object.props.style,
                borderTopLeftRadius: that.state.borderTopLeftRadius + "px",
                borderTopRightRadius: that.state.borderTopRightRadius + "px",
                borderBottomRightRadius: that.state.borderBottomRightRadius + "px",
                borderBottomLeftRadius: that.state.borderBottomLeftRadius + "px",
            }
        } else {
            _clone.components[0].object.props.style = {
                ..._clone.components[0].object.props.style,
                borderTopLeftRadius: that.state.borderTopLeftRadius + "px",
                borderTopRightRadius: that.state.borderTopRightRadius + "px",
                borderBottomRightRadius: that.state.borderBottomRightRadius + "px",
                borderBottomLeftRadius: that.state.borderBottomLeftRadius + "px",
            }
        }



        let _newEditor = JSON.parse(JSON.stringify(this.props.editor))
        let _result = findObjUpdate(_newEditor, _clone);
        this.props.updateComponent(_clone);
        this.props.onUpdateList(_result);
    }


    handleChange = (event) => {
        const { target } = event;
        const { name } = target;
        let value = (event.target.validity.valid) ? event.target.value : (this.state.isAll ? this.state.borderTopWidth : this.state[name]);
        const that = this;

         if (value.length < 1) { value = "0" }

        value = parseInt(value);

        if (this.state.isAll) {
            this.setState({
                borderTopLeftRadius: value,
                borderTopRightRadius: value,
                borderBottomRightRadius: value,
                borderBottomLeftRadius: value,
            }, () => {
                that.setProperties();
            });
        } else {
            this.setState({
                [name]: value,
            }, () => {
                that.setProperties();
            });
        }


    }

    componentDidMount() {
        this.setState({
            isAll: this.checkIsEqual(),
        })
    }
    componentDidUpdate = (prevProps) => {

        const { component } = this.props;
        const { object } = component.hasOwnProperty("componentOwner") ? component.object.components[0] : component.components[0];
        const { style, value } = object.props;

        if (prevProps.component != component) {
            this.setState({
                //isAll: this.checkIsEqual(),
                borderTopLeftRadius: parseInt(style["borderTopLeftRadius"] == undefined ? "0px" : style["borderTopLeftRadius"]),
                borderTopRightRadius: parseInt(style["borderTopRightRadius"] == undefined ? "0px" : style["borderTopRightRadius"]),
                borderBottomRightRadius: parseInt(style["borderBottomRightRadius"] == undefined ? "0px" : style["borderBottomRightRadius"]),
                borderBottomLeftRadius: parseInt(style["borderBottomLeftRadius"] == undefined ? "0px" : style["borderBottomLeftRadius"]),
            })
        }
    }
    handleChangeType = () => {
        this.setState({
            isAll: !this.state.isAll,
            borderTopLeftRadius: !this.state.isAll ? this.state.borderTopLeftRadius : this.state.borderTopLeftRadius,
            borderTopRightRadius: !this.state.isAll ? this.state.borderTopLeftRadius : this.state.borderTopRightRadius,
            borderBottomRightRadius: !this.state.isAll ? this.state.borderTopLeftRadius : this.state.borderBottomRightRadius,
            borderBottomLeftRadius: !this.state.isAll ? this.state.borderTopLeftRadius : this.state.borderBottomLeftRadius,
        }, () => {
            this.setProperties();
        })
    }

    onKeyDown = (event) => {
        if (event.key === 'Enter') { event.preventDefault() }
    }


    render() {
        const { component } = this.props;
        const { isAll } = this.state;
        return (
            <Translation>
                {t => (
                    <div>

                        <InputGroup className="mb-3">
                            <InputGroupAddon addonType="prepend">
                                <Button onClick={this.handleChangeType} size="sm" color="primary" outline={!isAll} type="button">
                                    <i className="far fa-square"></i>
                                </Button>
                                <Button onClick={this.handleChangeType} size="sm" color="primary" outline={isAll} type="button">
                                    <i className="fas fa-expand"></i>
                                </Button>
                            </InputGroupAddon>
                            {
                                isAll ? (
                                    <Input
                                        pattern="[0-9]*"
                                        name={"borderTopLeftRadius"}
                                        value={this.state.borderTopLeftRadius}
                                        onBlur={() => { }}
                                        onKeyDown={this.onKeyDown.bind(this)}
                                        onInput={this.handleChange.bind(this)}
                                        className="form-control-sm"
                                        placeholder="" type="text" />
                                ) : (
                                        <>
                                            <Input
                                                id={"border-left-top-radius"}
                                                name={"borderTopLeftRadius"}
                                                value={this.state.borderTopLeftRadius}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target="border-left-top-radius">
                                                {t("PROPERTY_LAYOUT_BORDER_RADIUS_TL")}
                                            </UncontrolledTooltip>

                                            <Input
                                                id={"border-right-top-radius"}
                                                name={"borderTopRightRadius"}
                                                value={this.state.borderTopRightRadius}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target="border-right-top-radius">
                                                {t("PROPERTY_LAYOUT_BORDER_RADIUS_TR")}
                                            </UncontrolledTooltip>
                                            <Input
                                                id={"border-bottom-rigth-radius"}
                                                name={"borderBottomRightRadius"}
                                                value={this.state.borderBottomRightRadius}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={0}
                                                placement="top"
                                                target="border-bottom-rigth-radius">
                                                {t("PROPERTY_LAYOUT_BORDER_RADIUS_BR")}
                                            </UncontrolledTooltip>
                                            <Input
                                                id={"border-bottom-left-radius"}
                                                name={"borderBottomLeftRadius"}
                                                value={this.state.borderBottomLeftRadius}
                                                onKeyDown={this.onKeyDown.bind(this)}
                                                onBlur={() => { }}
                                                onChange={(e) => {
                                                    this.handleChange(e)
                                                }}
                                                className="form-control-sm"
                                                placeholder="" type="text" />
                                            <UncontrolledTooltip
                                                delay={3}
                                                placement="top"
                                                target="border-bottom-left-radius">
                                                {t("PROPERTY_LAYOUT_BORDER_RADIUS_BL")}
                                            </UncontrolledTooltip>
                                        </>
                                    )
                            }



                        </InputGroup>

                    </div>

                )}
            </Translation>
        )
    }
}

//export default InputGenerator
const mapStateToProps = (state) => {
    const { componentReducer,editorReducer } = state;
    const { component } = componentReducer;
    const { present } = editorReducer;
    const { editor } = present;

    return {
        component,
        editor
    };
}
const mapDispatchToProps = {
    onUpdateList: updateList,
    updateComponent,
}
export default connect(mapStateToProps, mapDispatchToProps)(BorderRadius)
